module.exports = __webpack_public_path__ + "static/media/RescueDiver.23845acc.jpg";